module.exports = __webpack_public_path__ + "img/ready-to-scan-1.94220a0d.png";